import Vue from 'vue'
import Vuex from 'vuex'

// 新加
import tagsView from './modules/tags-view'

Vue.use(Vuex)


const store = new Vuex.Store({
    modules: {
        tagsView
    },
    state: {
        routers: null
    },
    mutations: {
        setRouters(state, val) {
            state.routers = val;
        },
    }
})


export default store


// WEBPACK FOOTER //
// ./src/store/index.js